import { useDocument } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "../firebase/clientApp.js"; // Assicurati di avere la configurazione di Firebase
import { Box, Typography, CircularProgress } from "@mui/material";

export default function Result() {
    const [value, loading, error] = useDocument(
        doc(db, "totem-terna-7-marzo-2025", "event", "users", "lastuser"),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );

    if (loading) return <CircularProgress />;
    if (error) console.info(error);
    if (error) return <Typography color="error">Errore nel recupero dati</Typography>;

    const userData = value?.data();
    const nome = userData?.nome || "In attesa...";
    const cognome = userData?.cognome || "In attesa...";
    const score = userData?.score ?? null;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                backgroundImage:'url("/images/monitor-bkg.png")',
                backgroundSize:'cover',
                padding:'32px'
            }}
        >

            <Typography className={'nome-cognome'} variant="h3" textAlign={'right'} fontWeight={'bold'}>
                {nome}
            </Typography>
        </Box>
    );
}
